import type { ToastDesignTokens, ToastTokenSections } from '@openng/optimus-ui-themes/types/toast';

/** The toast keeps its 25.375rem width while the viewport leaves it the library's 20px top-right offset on both sides. */
export const root: ToastTokenSections.Root = {
	width: 'min(25.375rem, 100vw - 2.5rem)',
};

export const text: ToastTokenSections.Text = {
	gap: '1rem',
};

export const detail: ToastTokenSections.Detail = {
	fontWeight: '400',
	fontSize: '1rem',
};

export const colorScheme: ToastTokenSections.ColorScheme = {
	light: {
		info: {
			background: '{feedback.info.background}',
			borderColor: '{feedback.info.border.color}',
			color: '{feedback.info.color}',
			shadow: '0px 4px 8px 0px color-mix(in srgb, {primary.500}, transparent 96%)',
			closeButton: {
				hoverBackground: '{feedback.info.hover.background}',
				focusRing: {
					color: '{feedback.info.color}',
				},
			},
		},
		success: {
			background: '{feedback.success.background}',
			borderColor: '{feedback.success.border.color}',
			color: '{feedback.success.color}',
			closeButton: {
				hoverBackground: '{feedback.success.hover.background}',
				focusRing: {
					color: '{feedback.success.color}',
				},
			},
		},
		warn: {
			background: '{feedback.warn.background}',
			borderColor: '{feedback.warn.border.color}',
			color: '{feedback.warn.color}',
			closeButton: {
				hoverBackground: '{feedback.warn.hover.background}',
				focusRing: {
					color: '{feedback.warn.color}',
				},
			},
		},
		error: {
			background: '{feedback.danger.background}',
			borderColor: '{feedback.danger.border.color}',
			color: '{feedback.danger.color}',
			closeButton: {
				hoverBackground: '{feedback.danger.hover.background}',
				focusRing: {
					color: '{feedback.danger.color}',
				},
			},
		},
	},
};

export default {
	root,
	text,
	detail,
	colorScheme,
} satisfies ToastDesignTokens;
